import { AuthUser } from "../../../api/common";

// Props interface
export interface PasswordResetProps {
	setLoggedIn: (user: AuthUser) => void;
}

// Form state interface
export interface PasswordResetState {
	email: string;
	password: string;
	confirmPassword: string;
	loading: boolean;
	emailError: string;
	passwordError: string;
	confirmPasswordError: string;
	error: string;
	isTokenValid: boolean;
	token: string;
}

// Form errors interface
export interface PasswordResetFormErrors {
	emailError: string;
	passwordError: string;
	confirmPasswordError: string;
	error: string;
}

// Constants
export const EMAIL_PATTERN = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
export const PASSWORD_MIN_LENGTH = 8;

export interface PasswordResetViewModel {
	// State
	email: string;
	password: string;
	confirmPassword: string;
	loading: boolean;
	emailError: string;
	passwordError: string;
	confirmPasswordError: string;
	error: string;
	isTokenValid: boolean;
	token: string;

	// Handlers
	handleEmailChange: (event: { target: { value: React.SetStateAction<string> } }) => void;
	handlePasswordChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	handleConfirmPasswordChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	handlePasswordReset: (event: React.ChangeEvent<HTMLFormElement>) => Promise<void>;
	handlePasswordUpdate: (event: React.ChangeEvent<HTMLFormElement>) => Promise<void>;
}
